module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/feature_01-f6099b8630aec67c0d36e7bec19bd9d5.jpg";